<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (eventModel) {
    <div class="detail-page-action-bar">
        @if (eventPermissions.canSave || eventPermissions.canSaveDataBreach) {
            <button class="btn btn-cerrix" (click)="save()">
                <i class="fas fa-save"></i>
                <span data-uiid="event-save" class="d-none d-lg-inline">{{ 'detail.saveEvent' | t }}</span>
            </button>
        }

        @if (eventModel.ID > 0) {
            <span class="date-edited">
                {{ 'detail.lastSave' | t }} {{ eventModel.LastSaveDate | dateTimeFormat }}
            </span>
        }

        <div class="workflow-area">
            <span class="workflow-description">
                {{ 'detail.workflowStatusLabel' | t }}
                <b>{{
                    eventModel.Workflow && eventModel.Workflow.StatusDescription
                        ? eventModel.Workflow.StatusDescription
                        : ('detail.workflowNewEvent' | t)
                }}</b>
                <i
                    class="far fa-question-circle mx-2"
                    [matTooltip]="
                        eventModel.Workflow && eventModel.Workflow.StatusDescription
                            ? eventModel.Workflow.StatusDescription
                            : ('detail.workflowCurrentlyStatus' | t)
                    "
                ></i>
            </span>
            @if (nextStatus) {
                <button
                    type="button"
                    (click)="newCommentDialog(true)"
                    class="btn btn-success"
                    id="positive"
                    title="{{ titlePos }}"
                >
                    {{ nextStatus }}
                </button>
            }
            @if (backStatus) {
                <button
                    (click)="newCommentDialog(false)"
                    class="btn btn-danger"
                    id="negative"
                    title="{{ titleNeg }}"
                >
                    {{ backStatus }}
                </button>
            }
        </div>
    </div>

    <div
        class="event-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div class="event-screens" [attr.name]="'detail.menuEvent' | t" menuItemId="Event" menuicon="fas fa-bolt" menusystemsubmenu>
            <div [attr.name]="'detail.menuDetails' | t" menuItemId="menuItemDetails" menuicon="fas fa-info-circle" menusystemitem>
                <event-detail-main
                    [eventModel]="eventModel"
                    [sdLight]="sdLight"
                    [sdHeavy]="sdHeavy"
                    [parentForm]="parentForm"
                    [permissions]="eventPermissions"
                    novalidate
                ></event-detail-main>
            </div>
            <div
                data-uiid="event-databreach"
                [attr.name]="'detail.menuDataBreach' | t"
                menuItemId="menuItemDataBreach"
                menuicon="fas fa-unlock-alt"
                menusystemitem
            >
                <breach-detail
                    #dataBreachTab
                    [eventForm]="parentForm"
                    [eventPermissions]="eventPermissions"
                >
                </breach-detail>
            </div>
            <div
                class="event-screens"
                [attr.name]="'detail.menuLinks' | t"
                menuItemId="Links"
                menuicon="fas fa-link"
                menusystemsubmenu
            >
                @if (eventModel.ID > 0) {
                    <div [attr.name]="'detail.menuMeasuresOfImprovement' | t" menuItemId="menuItemMeasuresOfImprovement" menuicon="fas fa-tasks" menusystemitem>
                        <linked-moi-overview
                            [moiType]="lerMoiType"
                            [parentGuid]="eventModel.Guid"
                            [canAdd]="eventPermissions.canAddMoi"
                            [canDelete]="eventPermissions.canDeleteMoi"
                            #eventMoisComponent
                        >
                        </linked-moi-overview>
                    </div>
                    <div [attr.name]="'detail.menuRisks' | t" menuItemId="menuItemRisks" menuicon="fas fa-exclamation-triangle" menusystemitem>
                        <event-risk
                            [disabled]="!eventPermissions.canLinkRisks"
                            [eventModel]="eventModel"
                            [parentForm]="parentForm"
                            (linkChanged)="checkDirty()"
                            #eventRiskComponent
                        >
                        </event-risk>
                    </div>
                    <div [attr.name]="'detail.menuControls' | t" menuItemId="menuItemControls" menuicon="fas fa-shield-alt" menusystemitem>
                        <event-control
                            [disabled]="!eventPermissions.canLinkControls"
                            [eventModel]="eventModel"
                            [parentForm]="parentForm"
                            (linkChanged)="checkDirty()"
                            #eventControlComponent
                        >
                        </event-control>
                    </div>
                }
                <div
                    [attr.name]="'detail.menuDocuments' | t"
                    menuItemId="menuItemDocuments"
                    menuicon="far fa-file"
                    menusystemitem
                >
                    <div>
                        @if (documents) {
                            <document-manager-old
                                [(Documents)]="eventModel.Documents"
                                (DocumentsChange)="checkDocumentsDirty()"
                                [permissions]="eventPermissions.documentPermissions"
                                [DocumentTypeTargets]="targetModule"
                            ></document-manager-old>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
                <div
                    [attr.name]="'detail.menuHyperlinks' | t"
                    [attr.menuItemID]="hyperlinksMenuItemId"
                    menuicon="fas fa-external-link-alt"
                    menusystemitem
                >
                    <div>
                        @if (eventModel.Hyperlinks) {
                            <hyperlink-manager
                                [Hyperlinks]="eventModel.Hyperlinks"
                                (HyperlinksChanged)="checkHyperlinksDirty()"
                                [TargetModule]="targetModule"
                            ></hyperlink-manager>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>
            </div>
            @if (eventModel.ID > 0) {
                <div [attr.name]="'detail.menuHistory' | t" menuItemId="History" menuicon="fas fa-history" menusystemsubmenu>
                    <div [attr.name]="'detail.menuEventHistory' | t" menuItemId="menuItemEventHistory" menuicon="fas fa-bolt" menusystemitem>
                        <app-history-overview
                            [historyDataService]="_eventDS"
                            [Id]="eventModel.Guid"
                            [useOldHistory]="true"
                            [label]="'detail.historyLabelEvent' | t"
                            #eventHistoryOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                    <div [attr.name]="'detail.menuDataBreachHistory' | t" menuItemId="menuItemDataBreachHistory" menuicon="fas fa-unlock-alt" menusystemitem>
                        <app-history-overview
                            [historyDataService]="_breachDS"
                            [Id]="eventModel.DataBreachGuid"
                            [useOldHistory]="true"
                            #breachHistoryOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                </div>
                <div [attr.name]="'detail.menuOptions' | t" menuItemId="menuItemOptions" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="event"
                        [objectName]="eventModel ? eventModel.Name : 'event'"
                        [allowDelete]="eventPermissions.isAdmin"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
